import { createRouter, createWebHistory } from 'vue-router'
import authAPI from '../api/auth'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('../views/Login.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () => import('../views/Register.vue'),
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局认证状态变量
let isAuthenticated = false
let authStateReady = false

// 监听认证状态变化
authAPI.onAuthStateChanged((user) => {
  isAuthenticated = !!user
  authStateReady = true
})

router.beforeEach(async (to, from, next) => {
  // 如果认证状态还没准备好，等待一小段时间
  if (!authStateReady) {
    await new Promise(resolve => setTimeout(resolve, 100))
  }
  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresGuest = to.matched.some(record => record.meta.requiresGuest)
  
  if (requiresAuth && !isAuthenticated) {
    // 需要登录的页面，但用户未登录
    next('/login')
  } else if (requiresGuest && isAuthenticated) {
    // 访客页面，但用户已登录
    next('/dashboard')
  } else {
    // 其他情况正常放行
    next()
  }
})

export default router 